export const ROLE_ADMIN = 'A';
export const ROLE_FACILITATOR = 'F';
export const ROLE_PARENT = 'P';

export const normalizeRole = (role) => {
  if (role === ROLE_ADMIN || role === ROLE_FACILITATOR || role === ROLE_PARENT) {
    return role;
  }

  // Backward compatibility for legacy sessions and API responses.
  if (role === 'C' || role === 'true') {
    return ROLE_FACILITATOR;
  }

  return null;
};

export const isAdminRole = (role) => {
  const normalizedRole = normalizeRole(role);

  return normalizedRole === ROLE_ADMIN || normalizedRole === ROLE_FACILITATOR;
};

export const hasFullFacilitatorProgramAccessRole = (role) =>
  normalizeRole(role) === ROLE_ADMIN;

export const isParentRole = (role) => normalizeRole(role) === ROLE_PARENT;

export const getStoredRole = () => {
  const storedRole = normalizeRole(localStorage.getItem('role'));

  if (storedRole) {
    return storedRole;
  }

  const legacyCoachRole = normalizeRole(localStorage.getItem('coach'));

  if (legacyCoachRole) {
    localStorage.setItem('role', legacyCoachRole);
    localStorage.removeItem('coach');
    return legacyCoachRole;
  }

  return null;
};

export const setStoredRole = (role) => {
  const normalizedRole = normalizeRole(role);

  if (!normalizedRole) {
    localStorage.removeItem('role');
    localStorage.removeItem('coach');
    return null;
  }

  localStorage.setItem('role', normalizedRole);
  localStorage.removeItem('coach');

  return normalizedRole;
};
